const initialState = () => ({
  currentJob: null,
  jobResult: null,
});

const state = initialState();

const actions = {
  onConnecting({ commit }, { jobId }) {
    commit('INIT', { jobId });
  },

  onStreaming({ commit }, { jobId }) {
    commit('UPDATE', { jobId, phase: 'streaming' });
  },

  onProgress({ commit }, { jobId, ssePayload }) {
    commit('UPDATE', { jobId, ssePayload, phase: 'streaming' });
  },

  onEnd({ commit, dispatch }, { jobId, status, ssePayload, opportunityId }) {
    commit('END', { jobId, status, ssePayload });
    if (status === 'COMPLETED') {
      dispatch('tasks/getOpportunityTasks', { opportunityId }, { root: true });
    }
  },

  onJobResultAvailable({ commit, dispatch }, { jobResult, opportunityId }) {
    commit('ON_JOB_RESULT_AVAILABLE', { jobResult });
    if (jobResult.status === 'COMPLETED') {
      dispatch('tasks/getOpportunityTasks', { opportunityId, silent: true }, { root: true });
    }
  },
};

const mutations = {
  RESET(state) {
    Object.assign(state, initialState());
  },

  INIT(state, { jobId }) {
    state.jobResult = null;
    state.currentJob = {
      jobId,
      phase: 'connecting', // 'connecting' | 'streaming'
      step: null,
      receivedSteps: [],
      currentDocument: null,
      currentProgress: null,
    };
  },

  UPDATE(state, { jobId, ssePayload, phase }) {
    state.jobResult = null;

    const defaultJob = {
      jobId,
      phase: 'connecting',
      step: state.currentJob && state.currentJob.step ? state.currentJob.step : null,
      receivedSteps: state.currentJob && state.currentJob.receivedSteps ? state.currentJob.receivedSteps : [],
      currentDocument: state.currentJob && state.currentJob.currentDocument ? state.currentJob.currentDocument : null,
      currentProgress: state.currentJob && state.currentJob.currentProgress ? state.currentJob.currentProgress : null,
    };
    state.currentJob = {
      ...(state.currentJob ? state.currentJob : {}),
      jobId,
      phase: phase || defaultJob.phase,
      currentDocument: ssePayload && ssePayload.document ? ssePayload.document : defaultJob.currentDocument,
      currentProgress: ssePayload && ssePayload.progress != null ? ssePayload.progress : defaultJob.currentProgress,
      step: ssePayload && ssePayload.step ? ssePayload.step : defaultJob.step,
      receivedSteps:
        state.currentJob && state.currentJob.receivedSteps ? state.currentJob.receivedSteps : defaultJob.receivedSteps,
    };
    if (ssePayload && ssePayload.step && !state.currentJob.receivedSteps.includes(ssePayload.step)) {
      state.currentJob.receivedSteps.push(ssePayload.step);
    }
  },

  END(state, { jobId, status, ssePayload }) {
    state.jobResult = {
      jobId: state.currentJob ? state.currentJob.jobId : jobId,
      status,
      error: status === 'failed' ? (ssePayload && ssePayload.error) || null : null,
      completedAt: Date.now(),
    };
    state.currentJob = null;
  },

  ON_JOB_RESULT_AVAILABLE(state, { jobResult }) {
    state.jobResult = {
      jobId: jobResult.id,
      status: jobResult.status,
      documentsUsed: jobResult.documents_used ? jobResult.documents_used : [],
      completedAt: jobResult.updated_at ? new Date(jobResult.updated_at).getTime() : null,
      error: jobResult.error_message ? jobResult.error_message : null,
    };
    state.currentJob = null;
  },
};

const getters = {
  isRequirementsExtracting: (state) => !!state.currentJob,
  requirementsCurrentStep: (state) => (state.currentJob ? state.currentJob.step : null),
};

export const requirementsExtraction = {
  namespaced: true,
  state,
  mutations,
  getters,
  actions,
};
